// extracted by mini-css-extract-plugin
module.exports = {"recipeDescriptionWrapper":"RecipeDescription_recipeDescriptionWrapper__ouqXI","recipeDescription":"RecipeDescription_recipeDescription__lWkP5"};